import { render, staticRenderFns } from "./TopBanners.vue?vue&type=template&id=0c18d2a6"
import script from "./TopBanners.vue?vue&type=script&lang=js"
export * from "./TopBanners.vue?vue&type=script&lang=js"
import style0 from "./TopBanners.vue?vue&type=style&index=0&id=0c18d2a6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports